'use client';

import React from 'react';
import { StyledCtaBanner } from './WordCounterTool.styles';

export const CtaBanner = () => {
  return (
    <StyledCtaBanner>
      <div className="banner-inner">
        <h2>Make every word on your page work harder</h2>
        <p>
          CommonNinja has 226+ widgets: accordions, tabs, comparison tables,
          all free to try. Works on any website, no coding needed.
        </p>
        <a className="banner-cta" href="/widgets">Browse all free widgets →</a>
      </div>
    </StyledCtaBanner>
  );
};
